module.exports = __webpack_public_path__ + "img/alert.8f4d88db.svg";